module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lt-2ea82cfcd24756f9d718925a52c8efa7.svg";